import styled from "styled-components";

import { fadeIn } from "@/styles/Mixins";
import { IThemeProps } from "@/styles/Theme";

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  height: 100%;
  text-align: center;
  background: #212529;
  font-family: "GothamCondensed", Helvetica, Tahoma, sans-serif;
  color: #fff;
`;

export const Header = styled.div`
  margin: 0 32px;
`;

export const Title = styled.div`
  line-height: 0.9;
  margin-bottom: 20px;
`;

export const TotalVotes = styled.div`
  font-family: "Gotham", Helvetica, Tahoma, sans-serif;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 800;
  opacity: 0.8;
  letter-spacing: 0.5px;
`;

export const VoteWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100vw;
`;

export const ThumbWrapper = styled.div`
  flex-direction: column;
  display: flex;
  align-items: center;
`;

type ThumbProps = IThemeProps<{ selected: boolean }>;
export const ThumbUp = styled.div<ThumbProps>`
  cursor: pointer;
  margin-bottom: 22px;
  will-change: transform;
  transition: all 250ms;
  transform: scale(${(props: ThumbProps) => (props.selected ? "1.1" : "1")});

  svg {
    height: 80px;
    width: 80px;
  }

  &:hover {
    transform: scale(1.1);
  }
`;

export const ThumbDown = styled(ThumbUp)`
  position: relative;
  bottom: -12px;
  transform: scale(${(props: ThumbProps) => (props.selected ? "-1.1" : "-1")});

  &:hover {
    transform: scale(-1.1);
  }
`;

export const ThumbVotes = styled.div`
  font-size: 30px;
  height: 1.4em;
  opacity: 0;
  animation: ${fadeIn} 150ms ease-in;
  animation-fill-mode: forwards;
`;

type FadeInTextProps = IThemeProps<{ delay?: number }>;
export const FadeInText = styled.span<FadeInTextProps>`
  opacity: 0;
  animation: ${fadeIn} 150ms ease-in
    ${(props: FadeInTextProps) => props.delay || 150}ms;
  animation-fill-mode: forwards;
`;

export const ThankYou = styled.div`
  width: 265px;
  height: 72px;
  margin: 15px 32px;
  font-size: 40px;
  line-height: 0.9;
  color: #dd0000;
`;
